import _extends from "@babel/runtime/helpers/esm/extends";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { createElement, Fragment } from "@wordpress/element";

/**
 * External dependencies
 */
import { isFunction, isString, map, negate } from 'lodash';
/**
 * WordPress dependencies
 */

import { Children, Component, cloneElement, isEmptyElement } from '@wordpress/element';
/**
 * Internal dependencies
 */

import { Consumer } from './context';

var SlotComponent =
/*#__PURE__*/
function (_Component) {
  _inherits(SlotComponent, _Component);

  function SlotComponent() {
    var _this;

    _classCallCheck(this, SlotComponent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SlotComponent).apply(this, arguments));
    _this.bindNode = _this.bindNode.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(SlotComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var registerSlot = this.props.registerSlot;
      registerSlot(this.props.name, this);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var unregisterSlot = this.props.unregisterSlot;
      unregisterSlot(this.props.name, this);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
          name = _this$props.name,
          unregisterSlot = _this$props.unregisterSlot,
          registerSlot = _this$props.registerSlot;

      if (prevProps.name !== name) {
        unregisterSlot(prevProps.name);
        registerSlot(name, this);
      }
    }
  }, {
    key: "bindNode",
    value: function bindNode(node) {
      this.node = node;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          name = _this$props2.name,
          _this$props2$bubblesV = _this$props2.bubblesVirtually,
          bubblesVirtually = _this$props2$bubblesV === void 0 ? false : _this$props2$bubblesV,
          _this$props2$fillProp = _this$props2.fillProps,
          fillProps = _this$props2$fillProp === void 0 ? {} : _this$props2$fillProp,
          getFills = _this$props2.getFills,
          className = _this$props2.className;

      if (bubblesVirtually) {
        return createElement("div", {
          ref: this.bindNode,
          className: className
        });
      }

      var fills = map(getFills(name, this), function (fill) {
        var fillKey = fill.occurrence;
        var fillChildren = isFunction(fill.children) ? fill.children(fillProps) : fill.children;
        return Children.map(fillChildren, function (child, childIndex) {
          if (!child || isString(child)) {
            return child;
          }

          var childKey = "".concat(fillKey, "---").concat(child.key || childIndex);
          return cloneElement(child, {
            key: childKey
          });
        });
      }).filter( // In some cases fills are rendered only when some conditions apply.
      // This ensures that we only use non-empty fills when rendering, i.e.,
      // it allows us to render wrappers only when the fills are actually present.
      negate(isEmptyElement));
      return createElement(Fragment, null, isFunction(children) ? children(fills) : fills);
    }
  }]);

  return SlotComponent;
}(Component);

var Slot = function Slot(props) {
  return createElement(Consumer, null, function (_ref) {
    var registerSlot = _ref.registerSlot,
        unregisterSlot = _ref.unregisterSlot,
        getFills = _ref.getFills;
    return createElement(SlotComponent, _extends({}, props, {
      registerSlot: registerSlot,
      unregisterSlot: unregisterSlot,
      getFills: getFills
    }));
  });
};

export default Slot;
//# sourceMappingURL=slot.js.map